import { Box } from "@mui/material";
import * as React from "react";
import { useEffect } from "react";

export default function MetaHeader({ children }) {
  useEffect(() => {
    document.title = "WA Group ERP System";
  }, []);

  return (
    <Box>
      {children}
    </Box>
  );
}
